import type { NavItem } from "./types";

export function filterNavItems(items: NavItem[], query: string): NavItem[] {
  const seen = new Set<string>();
  const deduped = items.filter((item) => {
    if (seen.has(item.label)) return false;
    seen.add(item.label);
    return true;
  });
  if (!query) return deduped.slice(0, 8);
  const lowerQuery = query.toLowerCase();
  return deduped
    .filter(
      (item) =>
        item.label.toLowerCase().includes(lowerQuery) ||
        item.pathname.toLowerCase().includes(lowerQuery) ||
        item.keywords?.some((k) => k.toLowerCase().includes(lowerQuery)),
    )
    .slice(0, 8);
}
